import axios from 'axios'
import BaseAPI from './base/base-api'

/**
 * Đầu api để gọi vào controller: TaxReturnController
 */
class TaxReturnAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'DeclareAPI';
    controllerName = 'taxreturn';
}

export default new TaxReturnAPI();